import { render, staticRenderFns } from "./ProductHistoryItem.vue?vue&type=template&id=50e9371a"
import script from "./ProductHistoryItem.vue?vue&type=script&lang=js"
export * from "./ProductHistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports